module.exports = __webpack_public_path__ + "static/media/corporate-services-img73.1eebfa75.jpg";